<template>
  <div
    v-if="matchData && matchData != null"
    class="match-stats-outer-container"
  >
    <!-- {{matchData}} -->

    <!-- Header -->
    <div class="header-container">
      <div class="logo">
        <img :src="wtalogo" />
      </div>
      <div class="centre-panel">
        <div class="event-info">
          <div class="spacer"></div>
          <div class="title" ref="titleRef" :class="{ multiline: isMultiLine }">
            {{ fullTitle }}
          </div>

          <div class="elapsed-time-by-set">
            <div>ELAPSED TIME BY SET</div>
          </div>

          <div class="set-info-container">
            <div class="set-time">
              <div
                class="set-time-val"
                v-if="sets[0] && sets[0].setDurationInMinutes"
              >
                {{ sets[0].setDurationInMinutes }}'
              </div>
              <div class="set-time-val" v-else></div>
            </div>
            <div class="set-time">
              <div
                class="set-time-val"
                v-if="sets[1] && sets[1].setDurationInMinutes"
              >
                {{ sets[1].setDurationInMinutes }}'
              </div>
              <div class="set-time-val" v-else></div>
            </div>
            <div class="set-time">
              <div
                class="set-time-val"
                v-if="sets[2] && sets[2].setDurationInMinutes"
              >
                {{ sets[2].setDurationInMinutes }}'
              </div>
              <div class="set-time-val" v-else></div>
            </div>
          </div>
        </div>

        <!-- Player 1 -->
        <div class="player-row">
          <div class="player-info">
            <div class="player-name">
              {{ matchData.player1Name }}
              <span
                v-if="
                  matchData.seed1 &&
                    matchData.seed1 !== '0' &&
                    !matchData.player1Name.includes('/')
                "
                class="seed"
              >
                [{{ matchData.seed1 }}]
              </span>
            </div>
            <div class="country-code">
              <span
                :style="{
                  visibility: displayedCode1Parts[0] ? 'visible' : 'hidden',
                }"
              >
                {{ displayedCode1Parts[0] || "XXX" }}
              </span>
              <span v-if="displayedCode1Parts[0] && displayedCode1Parts[1]"
                >/</span
              >
              <span
                v-else-if="!displayedCode1Parts[0] && displayedCode1Parts[1]"
                >/</span
              >
              <span
                :style="{
                  visibility: displayedCode1Parts[1] ? 'visible' : 'hidden',
                }"
              >
                {{ displayedCode1Parts[1] || "XXX" }}
              </span>
            </div>

            <div class="serve-info-container">
              <div class="server-icon" v-if="currentServer == 1">
                <img :src="serverIcon" />
              </div>
            </div>

            <div class="set-info-container">
              <div class="set">
                <div class="set-val" v-if="sets[0]">
                  {{ sets[0].player1Games }}
                </div>
                <div
                  class="tiebreak"
                  v-if="tieBreakData[0] && tieBreakData[0].player == '1'"
                >
                  {{ tieBreakData[0].points }}
                </div>
              </div>

              <div class="set">
                <div class="set-val" v-if="sets[1]">
                  {{ sets[1].player1Games }}
                </div>
                <div
                  class="tiebreak"
                  v-if="tieBreakData[1] && tieBreakData[1].player == '1'"
                >
                  {{ tieBreakData[1].points }}
                </div>
              </div>

              <div class="set">
                <div class="set-val" v-if="sets[2]">
                  {{ sets[2].player1Games }}
                </div>
                <div
                  class="tiebreak"
                  v-if="tieBreakData[2] && tieBreakData[2].player == '1'"
                >
                  {{ tieBreakData[2].points }}
                </div>
              </div>
            </div>
          </div>

          <div class="score">{{ currentScore[0] }}</div>
        </div>

        <!-- Player 2 -->
        <div class="player-row">
          <div class="player-info">
            <!-- <div class="colour-id2"></div> -->
            <!-- <div>
            <img
              :src="awayPlayerFlag"
              alt="Away Player Flag"
              class="flag-icon"
            />
          </div> -->
            <div class="player-name">
              {{ matchData.player2Name }}
              <span
                v-if="
                  matchData.seed2 &&
                    matchData.seed2 !== '0' &&
                    !matchData.player2Name.includes('/')
                "
                class="seed"
              >
                [{{ matchData.seed2 }}]
              </span>
            </div>

            <div class="country-code">
              <span
                :style="{
                  visibility: displayedCode2Parts[0] ? 'visible' : 'hidden',
                }"
              >
                {{ displayedCode2Parts[0] || "XXX" }}
              </span>
              <span v-if="displayedCode2Parts[0] && displayedCode2Parts[1]"
                >/</span
              >
              <span
                v-else-if="!displayedCode2Parts[0] && displayedCode2Parts[1]"
                >/</span
              >
              <span
                :style="{
                  visibility: displayedCode2Parts[1] ? 'visible' : 'hidden',
                }"
              >
                {{ displayedCode2Parts[1] || "XXX" }}
              </span>
            </div>

            <div class="serve-info-container">
              <div class="server-icon" v-if="currentServer == 2">
                <img :src="serverIcon" />
              </div>
              <!-- <div class="fastest-serve">Fastest Serve</div> -->
            </div>

            <!-- Player 2 set-info-container -->

            <div class="set-info-container">
              <div class="set">
                <div class="set-val" v-if="sets[0]">
                  {{ sets[0].player2Games }}
                </div>
                <div
                  class="tiebreak"
                  v-if="tieBreakData[0] && tieBreakData[0].player == '2'"
                >
                  {{ tieBreakData[0].points }}
                </div>
              </div>
              <div class="set">
                <div class="set-val" v-if="sets[1]">
                  {{ sets[1].player2Games }}
                </div>
                <div
                  class="tiebreak"
                  v-if="tieBreakData[1] && tieBreakData[1].player == '2'"
                >
                  {{ tieBreakData[1].points }}
                </div>
              </div>
              <div class="set">
                <div class="set-val" v-if="sets[2]">
                  {{ sets[2].player2Games }}
                </div>
                <div
                  class="tiebreak"
                  v-if="tieBreakData[2] && tieBreakData[2].player == '2'"
                >
                  {{ tieBreakData[2].points }}
                </div>
              </div>
            </div>
          </div>
          <div class="score">{{ currentScore[1] }}</div>
        </div>

        <!-- <div class="points-time-info">
          <div class="spacer"></div>

          <div class="last-10-points">
            <div class="title" v-if="last10Points">Last 10 Points</div>
          </div>

          <div class="last-10-points-discs" v-if="last10Points">
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point1 == 1,
                onplayer2: last10Points.point1 == 2,
              }"
            >
              1
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point2 == 1,
                onplayer2: last10Points.point2 == 2,
              }"
            >
              2
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point3 == 1,
                onplayer2: last10Points.point3 == 2,
              }"
            >
              3
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point4 == 1,
                onplayer2: last10Points.point4 == 2,
              }"
            >
              4
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point5 == 1,
                onplayer2: last10Points.point5 == 2,
              }"
            >
              5
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point6 == 1,
                onplayer2: last10Points.point6 == 2,
              }"
            >
              6
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point7 == 1,
                onplayer2: last10Points.point7 == 2,
              }"
            >
              7
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point8 == 1,
                onplayer2: last10Points.point8 == 2,
              }"
            >
              8
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point9 == 1,
                onplayer2: last10Points.point9 == 2,
              }"
            >
              9
            </div>
            <div
              class="circle"
              v-bind:class="{
                onplayer1: last10Points.point10 == 1,
                onplayer2: last10Points.point10 == 2,
              }"
            >
              10
            </div>
          </div>

         
        </div> -->
      </div>
      <!-- <div class="logo">
        <img :src="wtalogo" />
      </div> -->
    </div>
    <div class="container">
      <div class="image-wrapper">
        <img src="../assets/LSAT40.png" class="background-image" />
        <div class="overlay">
          <!-- Player 1 Row -->
          <div class="player-row40">
            <div class="player-name40">
              {{ matchData.player1Name }}
              <span
                v-if="
                  matchData.seed1 &&
                    matchData.seed1 !== '0' &&
                    !matchData.player1Name.includes('/')
                "
                class="seed"
                >[{{ matchData.seed1 }}]</span
              >
            </div>
            <div class="dots">
              <span
                v-for="(dot, index) in player1Dots"
                :key="'p1-' + index"
                class="dot"
                :class="{ active: dot.isActive }"
              ></span>
            </div>
            <div class="score40">{{ player1Score }}</div>
            <!-- Score after dots -->
          </div>

          <!-- Divider -->
          <div class="divider"></div>

          <!-- Player 2 Row -->
          <div class="player-row40">
            <div class="player-name40">
              {{ matchData.player2Name }}
              <span
                v-if="
                  matchData.seed2 &&
                    matchData.seed2 !== '0' &&
                    !matchData.player2Name.includes('/')
                "
                class="seed"
                >[{{ matchData.seed2 }}]</span
              >
            </div>
            <div class="dots">
              <span
                v-for="(dot, index) in player2Dots"
                :key="'p2-' + index"
                class="dot"
                :class="{ active: dot.isActive }"
              ></span>
            </div>
            <div class="score40">{{ player2Score }}</div>
            <!-- Score after dots -->
          </div>
        </div>
      </div>
    </div>

    <!-- Stats titles -->

    <div class="stats-title-container">
      <div class="set-header-title-empty"></div>
      <div class="set-header-title-empty"></div>
      <div class="set-header-title">Set 1</div>
      <div class="set-header-title">Set 2</div>
      <div class="set-header-title">Set 3</div>
      <div class="match-header-title">Match</div>
    </div>

    <!--
     *****************************
     STATS
    *****************************-->
    <div class="stats-container">
      <!-- Aces -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>Aces</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].ACES_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].ACES_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].ACES_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].ACES_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].ACES_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].ACES_PLAYER2 || "\u200B" }}
          </div>

          <div class="stat2 " v-else>&#8203;</div>

          <div class="stat">{{ matchData.ACES_PLAYER1 || "\u200B" }}</div>
          <div class="stat">{{ matchData.ACES_PLAYER2 || "\u200B" }}</div>
        </div>
      </div>

      <!-- Double Faults -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>Double Faults</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].DOUBLE_FAULTS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].DOUBLE_FAULTS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].DOUBLE_FAULTS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].DOUBLE_FAULTS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].DOUBLE_FAULTS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].DOUBLE_FAULTS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.DOUBLE_FAULTS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.DOUBLE_FAULTS_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- >First Serve (Num/%) -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>First Serve</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FIRST_SERVES_IN_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FIRST_SERVES_IN_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FIRST_SERVES_IN_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FIRST_SERVES_IN_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FIRST_SERVES_IN_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FIRST_SERVES_IN_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.FIRST_SERVES_IN_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.FIRST_SERVES_IN_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- PTS Won on 1st Serve (Num/%) -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>1<sup class="no-uppercase">st</sup> Serve Points Won</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FIRST_SERVES_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FIRST_SERVES_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FIRST_SERVES_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FIRST_SERVES_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FIRST_SERVES_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FIRST_SERVES_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.FIRST_SERVES_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.FIRST_SERVES_WON_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- PTS Won on 2nd Serve (Num/%) -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>2<sup class="no-uppercase">nd</sup> Serve Points Won</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].SECOND_SERVES_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].SECOND_SERVES_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].SECOND_SERVES_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].SECOND_SERVES_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].SECOND_SERVES_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].SECOND_SERVES_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.SECOND_SERVES_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.SECOND_SERVES_WON_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- Break Points Won/Chances -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>Break Points Won/Chances</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].BREAK_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].BREAK_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].BREAK_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].BREAK_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].BREAK_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].BREAK_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.BREAK_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.BREAK_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- Winners -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>Winners</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">{{ matchData.WINNERS_PLAYER1 || "\u200B" }}</div>
          <div class="stat">{{ matchData.WINNERS_PLAYER2 || "\u200B" }}</div>
        </div>
      </div>

      <!-- Unforced Errors-->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>Unforced Errors</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- FOREHAND_WINNERS -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>FOREHAND WINNERS</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FOREHAND_WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FOREHAND_WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FOREHAND_WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FOREHAND_WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FOREHAND_WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FOREHAND_WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.FOREHAND_WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.FOREHAND_WINNERS_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- BACKHAND_WINNERS -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>BACKHAND WINNERS</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].BACKHAND_WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].BACKHAND_WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].BACKHAND_WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].BACKHAND_WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].BACKHAND_WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].BACKHAND_WINNERS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.BACKHAND_WINNERS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.BACKHAND_WINNERS_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- FOREHAND_UNFORCED_ERRORS_-->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>FOREHAND UNFORCED ERRORS</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FOREHAND_UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FOREHAND_UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FOREHAND_UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FOREHAND_UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FOREHAND_UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FOREHAND_UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.FOREHAND_UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.FOREHAND_UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>
      <!-- BACKHAND_UNFORCED_ERRORS_-->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>BACKHAND UNFORCED ERRORS</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].BACKHAND_UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].BACKHAND_UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].BACKHAND_UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].BACKHAND_UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].BACKHAND_UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].BACKHAND_UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat">
            {{ matchData.BACKHAND_UNFORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.BACKHAND_UNFORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- Net Points Won -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>Net Points Won</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].NET_POINTS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].NET_POINTS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].NET_POINTS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].NET_POINTS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].NET_POINTS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].NET_POINTS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">{{ matchData.NET_POINTS_PLAYER1 || "\u200B" }}</div>
          <div class="stat">{{ matchData.NET_POINTS_PLAYER2 || "\u200B" }}</div>
        </div>
      </div>

      <!-- Forced Errors-->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>Forced Errors</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.FORCED_ERRORS_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.FORCED_ERRORS_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- Return Points Won (Num/%) -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>Return Points Won</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- POINTS_WON_BY_RETURN_WINNERS -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>POINTS WON BY RETURN WINNER</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].POINTS_WON_BY_RETURN_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].POINTS_WON_BY_RETURN_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].POINTS_WON_BY_RETURN_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].POINTS_WON_BY_RETURN_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].POINTS_WON_BY_RETURN_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].POINTS_WON_BY_RETURN_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.POINTS_WON_BY_RETURN_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.POINTS_WON_BY_RETURN_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- SERVE_GAME_WON_PLAYED -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>SERVE GAMES WON PLAYED</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].SERVICE_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].SERVICE_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].SERVICE_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].SERVICE_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].SERVICE_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].SERVICE_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.SERVICE_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.SERVICE_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>
      <!-- RETURN_GAMES_WON_PLAYED -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>RETURN GAMES WON PLAYED</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].RETURN_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].RETURN_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].RETURN_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].RETURN_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].RETURN_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].RETURN_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.RETURN_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.RETURN_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>
      <!-- TOTAL_GAMES_WON_PLAYED -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>TOTAL GAMES WON PLAYED</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].TOTAL_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].TOTAL_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].TOTAL_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].TOTAL_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].TOTAL_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].TOTAL_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.TOTAL_GAMES_WON_PLAYED_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.TOTAL_GAMES_WON_PLAYED_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- 1st Serve Return Points Won (Num/%) -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>1<sup class="no-uppercase">st</sup> Serve Return Points Won</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FIRST_SERVE_RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].FIRST_SERVE_RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FIRST_SERVE_RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].FIRST_SERVE_RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FIRST_SERVE_RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].FIRST_SERVE_RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>

          <div class="stat">
            {{ matchData.FIRST_SERVE_RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.FIRST_SERVE_RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>

      <!-- 2nd Serve Return Points Won (Num/%) -->
      <div class="stat-item-row">
        <div class="stat-title">
          <div>2<sup class="no-uppercase">nd</sup> Serve Return Points Won</div>
        </div>

        <div class="player-stats">
          <div class="stat0" v-if="sets[0]">
            {{ sets[0].SECOND_SERVE_RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat0" v-if="sets[0]">
            {{ sets[0].SECOND_SERVE_RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat0" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].SECOND_SERVE_RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat" v-if="sets[1]">
            {{ sets[1].SECOND_SERVE_RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat" v-else>&#8203;</div>

          <div class="stat2" v-if="sets[2]">
            {{ sets[2].SECOND_SERVE_RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat2" v-if="sets[2]">
            {{ sets[2].SECOND_SERVE_RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
          <div class="stat2" v-else>&#8203;</div>
          <div class="stat">
            {{ matchData.SECOND_SERVE_RETURN_POINTS_WON_PLAYER1 || "\u200B" }}
          </div>
          <div class="stat">
            {{ matchData.SECOND_SERVE_RETURN_POINTS_WON_PLAYER2 || "\u200B" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const wtalogo = require("@/assets/WTA.png");
const serverIcon = require("@/assets/player_serving.png");
export default {
  name: "MatchStats",
  props: {
    tournamentId: String,
    matchId: String,
  },
  data: () => ({
    wtalogo,
    serverIcon,
    maxDots: 40,
    player1Score: 0,
    player2Score: 0,
    isMultiLine: false,
  }),

  mounted() {
    if (this.matchData && this.matchData.loggedPoints) {
      this.loggedPoints = this.matchData.loggedPoints; // Use the JSON structure
    }
    this.updateScores(); // Ensure score is calculated when the component first loads
    this.$nextTick(() => {
      this.checkOverflow();

      window.addEventListener("resize", this.checkOverflow);
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkOverflow);
  },

  computed: {
    // ...mapGetters({
    //   // map `this.doneCount` to `this.$store.getters.doneTodosCount`
    //   matchStuff: "tennisData"
    // }),

    fullTitle() {
      if (!this.matchData) return "";

      return `${this.matchData.tournamentDescription || ""} ${this.matchData
        .roundName || ""}`.trim();
    },

    displayedCode1Parts() {
      return [
        this.filterCode(this.matchData.nationalityCodeA1),
        this.filterCode(this.matchData.nationalityCodeB1),
      ];
    },
    displayedCode2Parts() {
      return [
        this.filterCode(this.matchData.nationalityCodeA2),
        this.filterCode(this.matchData.nationalityCodeB2),
      ];
    },

    matchData() {
      // let data;

      if (this.$store.getters.numTournaments > 1) {
        // Multiple tournaments
        // Add a getter function here passing in tournamentId and matchId?
        // return this.$store.getters.getTennisData(
        //  this.tournamentId,
        //  this.matchId
        // );

        // return this.$store.state.tennisData.filter(i => i.tournamentID === this.tournamentId);

        if (this.$store.state.tennisData[this.tournamentId] !== null) {
          return this.$store.state.tennisData[
            this.tournamentId
          ].AETennis.Match.find((i) => i.matchID === this.matchId);
        } else {
          return null;
        }
      } else if (this.$store.getters.numTournaments == 1) {
        if (this.$store.getters.tennisData !== null) {
          // Single tournament
          return this.$store.getters.tennisData.AETennis.Match.find(
            (i) => i.matchID === this.matchId,
          );
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    loggedPoints() {
      return this.matchData && this.matchData.loggedPoints
        ? this.matchData.loggedPoints
        : [];
    },

    last40Points() {
      return this.loggedPoints.slice(-this.maxDots); // Get last 40 entries
    },
    player1Dots() {
      return this.getDotsArray(1);
    },
    player2Dots() {
      return this.getDotsArray(2);
    },
    // player1Score() {
    //   return this.calculateScore(1); // Get total points for Player 1
    // },
    // player2Score() {
    //   return this.calculateScore(2); // Get total points for Player 2
    // },

    sets() {
      return this.matchData.Sets;
    },
    currentScore() {
      return this.matchData.currentGameScore.split("-");
    },
    currentServer() {
      return this.matchData.currentServer;
    },
    currentSet() {
      return this.matchData.currentSet;
    },
    errorsMatchTotalPlayer1() {
      return parseInt(
        this.matchData.UNFORCED_ERRORS_PLAYER1 +
          this.matchData.FORCED_ERRORS_PLAYER1,
      );
    },
    errorsMatchTotalPlayer2() {
      return parseInt(
        this.matchData.UNFORCED_ERRORS_PLAYER2 +
          this.matchData.FORCED_ERRORS_PLAYER2,
      );
    },
    errorsSetTotalPlayer1() {
      return parseInt(
        this.sets[this.currentSet - 1].UNFORCED_ERRORS_PLAYER1 +
          this.sets[this.currentSet - 1].FORCED_ERRORS_PLAYER1,
      );
    },
    errorsSetTotalPlayer2() {
      return parseInt(
        this.sets[this.currentSet - 1].UNFORCED_ERRORS_PLAYER2 +
          this.sets[this.currentSet - 1].FORCED_ERRORS_PLAYER2,
      );
    },
    last10Points() {
      let pointsValues = Object.values(this.matchData.Last10Points); // The values of the objects' properties.
      let i;
      for (i = 0; i < pointsValues.length; i++) {
        if (pointsValues[i] !== "0") {
          return this.matchData.Last10Points;
        }
      }
      return 0;
    },
    tieBreakData() {
      if (this.sets.length >= 0) {
        let data = [];

        let i;
        for (i = 0; i < this.sets.length; i++) {
          if (this.sets[i].setFinished === "True") {
            // console.log("finished set " + i);

            if (
              this.sets[i].player1TieBreakPoints != "" &&
              this.sets[i].player2TieBreakPoints != ""
            ) {
              let obj = {};

              if (
                parseInt(this.sets[i].player1TieBreakPoints, 10) >
                parseInt(this.sets[i].player2TieBreakPoints, 10)
              ) {
                obj.player = 2;
                obj.points = this.sets[i].player2TieBreakPoints;
              } else {
                obj.player = 1;
                obj.points = this.sets[i].player1TieBreakPoints;
              }

              data.splice(i, 0, obj);
            } else {
              data.splice(i, 0, "");
            }
          }
        }

        // console.log(data);
        return data;
      }
      return null;
    },
    homePlayerFlag() {
      return this.getFlag(this.matchData.nationalityCodeA1);
    },
    awayPlayerFlag() {
      return this.getFlag(this.matchData.nationalityCodeA2);
    },
  },

  watch: {
    loggedPoints: {
      deep: true,
      handler() {
        this.$forceUpdate(); // Ensures UI updates on changes
        this.updateScores(); // Update score whenever loggedPoints changes
      },
    },
  },
  methods: {
    checkOverflow() {
      const el = this.$refs.titleRef;
      if (!el) return;

      // Real pixel overflow check
      const isOverflowing = el.scrollWidth > el.clientWidth;

      // Fallback length rule
      const isTooLong = this.fullTitle.length > 50;

      this.isMultiLine = isOverflowing || isTooLong;
      console.log({
        text: this.fullTitle,
        length: this.fullTitle.length,
        overflow: el.scrollWidth > el.clientWidth,
        multi: this.isMultiLine,
      });
    },

    filterCode(code) {
      return code === "RUS" || code === "BLR" ? null : code;
    },

    getFlag(code) {
      if (!code) return require("@/assets/flags/USA.png"); // Fallback image

      const flagMapping = {
        RUS: "Russia.png",
        BLR: "Belarus.png",
        USA: "USA.png",
        ENG: "United_Kingdom.png",
        CZE: "Czech_Republic.png",
        FRA: "France.png",
        GER: "Germany.png",
        AUS: "Australia.png",
        IND: "India.png",
        BEL: "Belgium.png",
        CHN: "China.png",
        CRO: "Croatia.png",
        GRE: "Greece.png",
        ITA: "Italy.png",
        JPN: "Japan.png",
        LAT: "Latvia.png",
        LUX: "Luxembourg.png",
        POL: "Poland.png",
        ESP: "Spain.png",
        SUI: "Switzerland.png",
        TUN: "Tunisia.png",
        UKR: "Ukraine.png",
      };

      return flagMapping[code]
        ? require(`@/assets/flags/${flagMapping[code]}`)
        : require("@/assets/flags/USA.png"); // Fallback
    },
    // getDotsArray(player) {
    //   let points = this.last40Points.slice().reverse(); // Reverse for right-to-left display
    //   let dotsArray = [];
    //   let prevGameNumber = null; // Track previous game number

    //   points.forEach((point) => {
    //     // Insert a divider if GameNumber changes
    //     if (prevGameNumber !== null && prevGameNumber !== point.GameNumber) {
    //       dotsArray.push({ isDivider: true });
    //     }

    //     // Add normal dots based on the PointWinner
    //     dotsArray.push({ isActive: point.PointWinner === player });

    //     prevGameNumber = point.GameNumber; // Update previous GameNumber
    //   });

    //   return dotsArray;
    // },

    getDotsArray(player) {
      let points = this.last40Points.slice().reverse(); // Reverse for right-to-left display

      let dotsArray = new Array(this.maxDots).fill({ isActive: false });

      points.forEach((point, index) => {
        if (point.PointWinner === player) {
          dotsArray[index] = { isActive: true };
        }
      });
      return dotsArray;
    },

    getPlayerScore(player) {
      let recentPoints = this.loggedPoints.slice(-40); // Take last 40 points
      return recentPoints.filter((point) => point.PointWinner === player)
        .length;
    },
    updateScores() {
      this.player1Score = this.getPlayerScore(1);
      this.player2Score = this.getPlayerScore(2);
    },
  },
};
</script>

<style scoped>
/* Green #bbda16
Purple #6a36a8 */

/* HEADER CONTAINER */

.header-container {
  display: flex;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
}

.logo {
  width: 25%;
  background-color: #000000;
  /* height: 10rem; */
  max-width: 40rem; /* Removed space in "10 rem" */
  display: flex;
  justify-content: flex-start; /* Aligns content to the left */
  align-items: center;
}

img {
  width: 65%;
}

.centre-panel {
  width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  border: 2px solid transparent;
  padding: 10px;
  position: relative;
  background-color: black;
  overflow: hidden;
}

/* Neon glow centered at the top */
.centre-panel::before {
  content: "";
  position: absolute;
  top: -5px;
  left: 50%;
  width: 60%;
  height: 25px;
  background: radial-gradient(
    circle,
    rgba(0, 231, 179, 0.8) 10%,
    transparent 80%
  );
  transform: translateX(-50%);
  opacity: 1;
  filter: blur(10px);
  pointer-events: none;
}

/* Border with different fading on top-left and bottom-right */
.centre-panel::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px;
  border: 2px solid #00e7b3;

  /* Custom fading */
  mask-image: linear-gradient(
      to right,
      rgba(0, 231, 179, 1) 0%,
      /* Start fully visible at top-left */ rgba(0, 231, 179, 1) 30%,
      /* Fades slowly near the top-right */ transparent 50%,
      /* Fully transparent at center-right */ transparent 70%,
      /* Keeps it transparent */ transparent 85%,
      /* Border reappears at bottom-right */ transparent 100%
        /* Fully visible at bottom-left */
    ),
    linear-gradient(
      to bottom,
      transparent 0%,
      /* Start fully visible at left */ rgba(0, 231, 179, 1) 80%,
      /* Stays visible */ rgba(0, 231, 179, 1) 100%
        /* Border visible again at bottom */
    );

  /* Blurring the effect slightly for a smoother transition */
  filter: blur(1px);
}

/* Event Info row */

.event-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  text-align: left;
  background-color: black;
  text-transform: uppercase;

  font-family: "GeneralSans Medium";

  min-height: 2rem; /* ← key change */
}

.event-info .spacer {
  width: 2%;
}
.event-info .title {
  width: 55%;
  color: #ffffff; /* RED */

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 1.45rem;
  line-height: 1.25;

  transition: all 0.2s ease;
}

/* When too long */
.event-info .title.multiline {
  white-space: normal;

  display: -webkit-box;
  -webkit-box-orient: vertical;

  -webkit-line-clamp: 2;
  line-clamp: 2;

  overflow: hidden;

  color: #ffffff; /* PURPLE (fix alpha) */

  font-size: 1.25rem;
  line-height: 1.15;
}

.flag-icon {
  height: 2rem;
  width: 3rem;
  padding-left: 4px;
}
.player-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 4px; /* Ensure space for border-radius */
}

.player-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  color: #2d0046;
  height: 3rem;
  background-color: #ffffff;
  border-radius: 8px;
  margin: 4px;
  flex-grow: 1; /* Take all available space */
  padding-right: 10px; /* Ensures border-radius visibility */
}

.score {
  flex-shrink: 0;
  width: 50px; /* Fixed width instead of percentage */
  text-align: center;
  font-weight: bold;
  color: #00e7b3;
  margin-left: 8px; /* Space from player-info */
}

.colour-id1,
.colour-id2 {
  width: 2%;
  height: 100%;
}

.colour-id1 {
  background-color: #00ffe5;
}

.colour-id2 {
  background-color: #ffffff;
}

.player-name,
.country-code,
.score {
  font-size: 1.8rem;
  font-weight: 400;
}

.player-name {
  padding-left: 1.5rem;
  width: 45%;
  font-size: 1.8rem; /* Default size for larger screens */
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Add "..." if text is too long */
}

.country-code {
  width: 15%;
  text-align: left;
  /* padding-right: 1rem; */
}

.serve-info-container {
  display: flex;
  width: 5%;
  text-align: center;
}

.fastest-serve,
.serve-icon {
  width: 50%;
  line-height: 1rem;
  text-align: center;
}

.server-icon img {
  width: 2rem;
  height: 2rem;
}

.on-serve1 {
  background: #04d3a9;
}

.on-serve2 {
  background: #36a88a;
}

.set-info-container {
  display: flex;
  width: 15%;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.set {
  flex-grow: 1;
  text-align: center;
  font-size: 1.5rem;
  color: #2d0046;
  background-color: #fff;
  height: 100%;
  display: flex;
  position: relative;
  width: 33%;
}

.set-val {
  margin: auto;
  width: 100%;
}

.tiebreak {
  position: absolute;
  right: 1.25rem;
  top: 0.25rem;
  font-size: 0.75rem;
}

div.set-time-val {
  font-size: 1.25rem;
}

/* Points-Time info row */
.points-time-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  height: 3rem;
  background-color: #000;
  color: #fff;
}

.spacer {
  width: 2%;
  height: 100%;
}

.last-10-points {
  width: 15%;
}

.points-time-info .title {
  font-size: 1.25rem;
}

.last-10-points-discs {
  width: 30%;
  display: flex;
  justify-content: space-between;
}

.circle {
  width: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
  border-radius: 0.75rem;
  font-size: 0.85rem;
  color: #fff;
  text-align: center;
  background-color: transparent;
  /* Changed from 'none' to 'transparent' */
  display: inline-block;
  border: 2px solid #00ff00;
}

.onplayer1 {
  background-color: #00ffffd9;
}

.onplayer2 {
  background-color: transparent;
}

.elapsed-time-by-set {
  width: 23%;
}

.elapsed-time-by-set div {
  text-align: right;
  padding-right: 1rem;
  font-size: 1.25rem;
}

.set-time {
  flex-grow: 1;
  height: 100%;
  display: flex;
  width: 33%;
}

.set-time-val {
  flex-grow: 1;
  color: #fff;
  text-align: center;
  font-size: 1.5rem;
  margin: auto;
}

/* STATS TITLE CONTAINER */

.stats-container {
  font-size: 1.2rem;
  font-family: "GeneralSans Bold";
  letter-spacing: 1px;

  padding: 0px 20px 0px 20px;
}

.stats-title-container {
  display: flex;
  justify-content: space-between;
  color: #ffffff;
  padding: 0px 20px 0px 20px;
  font-size: 1.25rem;
  font-family: "GeneralSans Medium";
}

.player-stats-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 40%;
  background-color: #ffffff;
  color: #000;
}

/* 
.player-stats-title.onplayer1 {
  color: #000000;
} */

.player-stats-name {
  font-weight: bold;
}

.player-stats-headers {
  display: flex;
  justify-content: center;
}

.set-header-title-empty {
  width: 15%;
  text-transform: uppercase;
}
.set-header-title {
  width: 17.5%;
  text-transform: uppercase;
}

.match-header-title {
  width: 17.5%;
  text-transform: uppercase;
}

.player-stats-time {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 20%;
}

.stat-item-row {
  display: flex;
  background: #2d0046;
}

.player-stats {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 70%;
}

.stat {
  text-align: center;
  width: 8.75%;
  flex-grow: 1;
}
.stat0,
.stat2 {
  text-align: center;
  width: 8.75%;
  flex-grow: 1;
  background-color: #3e1455;
  border-bottom: 1.5px solid #3e1455;
}
/* Ensure Empty Divs Maintain Width and Background */
.stat:empty,
.stat0:empty,
.stat2:empty {
  visibility: visible;
  content: "\00a0"; /* Non-breaking space to keep the height */
}

.stat-title {
  display: flex;
  align-items: flex-end;
  color: #fff;
  background-color: #2d0046;
  width: 30%;
  text-transform: uppercase;
  border-bottom: 1.5px solid;
  border-image-source: linear-gradient(
    to right,
    transparent,
    white,
    transparent
  );
  border-image-slice: 1;
  height: auto; /* Allow height to adjust based on content */
  font-family: "GeneralSans Medium";
}

.stat-title div {
  margin: auto;
  font-weight: 400;
}

.no-uppercase {
  text-transform: none;
  /* Prevents capitalization */
  font-size: 0.6em;
  /* Adjust font size for superscript */
  vertical-align: super;
  /* Aligns text to the top */
  line-height: 0;
  /* Removes extra spacing */
}
.container {
  padding: 0px 0px 0px 20px;
}

.image-wrapper {
  position: relative;
  width: 100%;
}

.background-image {
  width: 100%;
  height: auto;
  display: block;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 0;
}

.player-row40 {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  width: 100%;
}

.player-name40 {
  width: 29%;
  font-weight: bold;
  color: white;
  font-size: 24px;
  text-transform: uppercase;
  text-align: left;
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Add "..." if text is too long */
}

.dots {
  width: 63.3%;
  display: flex;
  flex-direction: row-reverse; /* Reverse order for right-to-left display */
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 2px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #333;
  transition: all 0.3s ease-in-out;
}

.dot.active {
  background-color: #76ffe4;
}
.score40 {
  width: 4.5%;
  text-align: right;
  font-weight: bold;
  font-size: 28px;
  color: rgb(23, 229, 198);
}
.divider {
  position: absolute;
  bottom: 49%; /* Adjust the distance from the bottom relative to image height */
  left: 50%;
  transform: translateX(-50%);
  width: 80%; /* Adjust width as needed */
  height: 2px;
  background: linear-gradient(
    to right,
    transparent,
    rgba(255, 255, 255, 0.8),
    transparent
  );
}

@media screen and (max-width: 1920px) {
  .player-name,
  .country-code {
    font-size: clamp(1.4rem, 1.5vw, 1.5rem); /* Dynamically adjust */
  }
  .player-name40 {
    font-size: clamp(20px, 1.8vw, 24px);
  }
}

/* Further decrease for tablets */
@media screen and (max-width: 768px) {
  .player-name,
  .country-code {
    font-size: clamp(1rem, 1.4vw, 1.2rem);
  }
  .player-name40 {
    font-size: clamp(16px, 1.6vw, 18px);
  }
}

/* Even smaller for very small screens */
@media screen and (max-width: 480px) {
  .player-name,
  .country-code {
    font-size: clamp(0.8rem, 1.2vw, 1rem);
  }
  .player-name40 {
    font-size: clamp(14px, 1.4vw, 16px);
  }
}
.seed {
  font-size: 12px;
  position: relative;
  top: -3px; /* Adjust this value to move it lower */
  letter-spacing: 2px; /* Adds space between characters */
}
</style>
